import './Node.scoped.scss'
import ToggleNode from 'Shared/components/ToggleNode'
import Chip from 'Shared/components/Chip'

// The CacheAllOrganisationLinksService stores parent_names as [self_name, immediate_parent, ..., root].
// We strip the first element when it matches the org's own name to avoid duplication.
function getAncestors(parentNames, name) {
  if (!Array.isArray(parentNames) || parentNames.length === 0) return []
  return parentNames[0] === name ? parentNames.slice(1) : parentNames
}

// Presentation that's common to the different types of tree nodes in the org picker
// - Root and child org
// - External type
// - Text nodes
export default function Node({
  name,
  parentNames,
  externalId,
  depth = 0,
  children,
  onClick,
  expandable,
  expanded,
  toggle,
  label,
  textOnly = false,
}) {
  const ancestors = getAncestors(parentNames, name)

  return (
    <div className={`org depth-${depth}`}>
      <div className="org-details" onClick={onClick}>
        {expandable && <ToggleNode expanded={expanded} onClick={toggle} />}
        <div className="org-label">
          <span className="org-name">
            {name}
            {externalId && <span className="org-external-id">{externalId}</span>}
          </span>
          {ancestors.length > 0 && (
            <span className="parent-names">
              {ancestors.map((ancestor, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <span className="parent-names-arrow">→</span>}
                  {ancestor}
                </React.Fragment>
              ))}
            </span>
          )}
        </div>
        {label && <Chip>{label}</Chip>}
        {!textOnly && <div className="arrow"><SvgIconsArrowRight variant="light" /></div>}
      </div>
      {children}
    </div>
  )
}

